/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	var innovationDetails = $('.innovation_details_wrapper')
	var innovationItemOpened = null;
	var currentInnovation = null;

	var windowWidth = $(window).width()
	var windowHeight = $(window).height()

	var last_known_scroll_position = 0, current_scroll = 0;
	var ticking = false;
	var allloaded = false

	var activedSpan = []

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				this.to = 0;

				var self = this
				$('.intro_arrow').click( function(){

					self.to = $(window).scrollTop()
					TweenLite.to(self, .5, {
			            to: $('#innovation').offset().top,
			            ease: Cubic.easeOut,
			            onUpdate: function(){
			            	$(window).scrollTop( self.to )
			            }
			        });
				})

				var mapOptions = {
						zoom: 14,
						disableDefaultUI: true,
						center: new google.maps.LatLng(48.8749602,2.2905606),
						styles: [{"stylers":[{"hue":"#ff1a00"},{"invert_lightness":true},{"saturation":-100},{"lightness":33},{"gamma":0.5}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#2D333C"}]}]
				};
				var mapElement = document.getElementById('map');
				var map = new google.maps.Map(mapElement, mapOptions);

				var url
				if( window.location.hostname == 'localhost' || window.location.hostname == "kaos.dev" ){
					url = "http://kaosconsulting-testing.sooyoos.com"
				}else{
					url = ""
				}

				var marker = new google.maps.Marker({
						position: new google.maps.LatLng(48.8749602,2.2905606),
						map: map,
						icon: url + "/wp-content/themes/kaos/dist/images/marker.png"
				});

				$('.innovation_item').each( function(i){
					$(this).data('num', i)
				})

				innovationDetails = $('.innovation_details_wrapper')
				innovationItemOpened = null;
				$('.innovation_intro').click( function(){

					var target = $(this).parent()
					if( $(this).find('a').length == 0 ){
						showInnovationDetails( target )
					}

				});


				// animation reference list
				if( $('.reference_list').length > 0 ){

					var spans = $('.reference_list span')
					var lgReference = spans.length
					var activedSpan = [], span

					// setInterval( function(){

					// 	for( var i = 0, lg = activedSpan.length; i<lg; i++ ){

					// 		$(activedSpan[ 0 ]).removeClass('active')
					// 		$(activedSpan[ 0 ]).css('transition-delay', '0s')
					// 		activedSpan.shift()

					// 	}

					// 	for( var i = 0; i<5; i++ ){

					// 		span = spans.eq( Math.floor( Math.random() * lgReference ) )
					// 		span.css('transition-delay', Math.random() * 2 + 's')
					// 		span.addClass('active')

					// 		activedSpan.push( span )

					// 	}

					// }, 300)

					for( var i = 0; i<6; i++ ){
						activeSpan()
					}

					setInterval( activeSpan.bind(this), 400 )

				}


				$('.input_text input').focus( function(){
					focus( $(this), false )
				})
				.blur( function(){
					unfocus( $(this), false )
				})

				$('.input_textarea textarea').focus( function(){
					focus( $(this), true )
				})
				.blur( function(){
					unfocus( $(this), true )
				})

				$(document).bind('gform_post_render', function(){

					$('.input_text input').each( function(){
						if( $(this).val() != '' ){
							focus( $(this), false )
						}
					})

					$('.input_textarea textarea').each( function(){
						if( $(this).val() != '' ){
							focus( $(this), true )
						}
					})

					$('.input_text input').focus( function(){
						focus( $(this), false )
					})
					.blur( function(){
						unfocus( $(this), false )
					})

					$('.input_textarea textarea').focus( function(){
						focus( $(this), true )
					})
					.blur( function(){
						unfocus( $(this), true )
					})

				})


				$(window).resize( function(){

					doResize()

					if( currentInnovation != null ){

						var num = currentInnovation.data('num')
						var details = $('.innovation_details_wrapper').eq( num )
						var h = details.find('.innovation_content').outerHeight()
						details.css('height', h)
					}

				})

				var imgs = document.images,
				    len = 0,
				    counter = 0;

				$('img').each( function(){
					$(this).css('opacity', 1)
					if( $(this).data('src') != undefined ){
						$(this)
							.attr('src', $(this).data('src') )
							.load( incrementCounter )

						len++
					}
				});

				var verbatims = $('.verbatim > div')
				var totalVerbatim = verbatims.length
				var nbVerbatim = 0
				setInterval( function(){
					verbatims.eq( nbVerbatim ).removeClass('active')
					nbVerbatim++
					if( nbVerbatim == totalVerbatim ){
						nbVerbatim = 0
					}
					verbatims.eq( nbVerbatim ).addClass('active')
				}, 10000 );

				window.addEventListener('scroll', function(e) {
				  	last_known_scroll_position = window.scrollY;
				  	// if (!ticking) {
					  //   window.requestAnimationFrame(function() {
					  //     	doScroll(last_known_scroll_position);
					  //     	ticking = false;
					  //   });
				  	// }
				  	ticking = true;
				});
				window.requestAnimationFrame( loop.bind(this) )

				// [].forEach.call( imgs, function( img ) {
				//     img.addEventListener( 'load', incrementCounter, false );
				// });

				function incrementCounter( el ) {
				    counter++;

				    if ( counter === len ) {
				    	allloaded = true
				    	doResize()
				    	doScroll( window.scrollY )
				    }
				}
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	function activeSpan(){

		var spans = $('.reference_list span')
		var lgReference = spans.length
		var span

		span = spans.eq( Math.floor( Math.random() * lgReference ) )
		span.css('transition-delay', Math.random() * 2 + 's')
		span.addClass('active')

		activedSpan.push( span )

		if( activedSpan.length > 10 ){

			$(activedSpan[ 0 ]).removeClass('active')
			$(activedSpan[ 0 ]).css('transition-delay', '0s')
			activedSpan.shift()

		}

	}

	function loop(){

		window.requestAnimationFrame( loop.bind(this) )

		current_scroll += ( last_known_scroll_position - current_scroll ) / 15

		if( Math.abs( current_scroll - last_known_scroll_position ) > 1 ){

			doScroll( current_scroll )

		}

	}

	function focus( el, textarea ){

		var input = el.parent().parent()
		// if( el.val() != '' ){
			input.removeClass('gfield_error').addClass('active')
		// }

		if( textarea == false ){
			var label = input.find('.gfield_label')

			label.css({
				transform: 'scale(.75) translateY(-26px)',
				transformOrigin: 'left center'
			})
		}


	}

	function unfocus( el, textarea ){
		if( el.val() == '' ){

			var input = el.parent().parent()
			input.removeClass('active')

			if( textarea == false ){

				var label = input.find('.gfield_label')

				label.css({
					transform: ''
				})
			}

		}
	}

	function showInnovationDetails( target ){

		if( ! target.hasClass('active') ){

			closeDetails( currentInnovation )
			openDetails( target )

		}else{

			closeDetails( target )

		}


	}

	function openDetails( target ){

		target.addClass('active');

		var num = target.data('num')
		var details = $('.innovation_details_wrapper').eq( num )
		details.find('.iframe-container').empty().html('&nbsp;')
		if( target.data('video') !== '' ){
			details.addClass('hasIframe')
		}
		var h = details.find('.innovation_content').outerHeight()

		var nb = 3
		if( windowWidth < 640 ){
			nb = 2
		}
		details.css('top', (Math.floor( num / nb ) + 1) * 260 )

		TweenLite.to( target, .6, { height: h + 220, ease:Cubic.easeInOut } )
		TweenLite.to( details, .6, { height: h, ease:Cubic.easeInOut, onComplete: function(){

			if( target.data('video') !== '' ){
				var iframe = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+target.data('video')+'" frameborder="0" allowfullscreen></iframe>');
				details.find('.iframe-container').empty().append( iframe );
			}else if( target.data('image') !== '' ){
				var image = $('<img src="'+target.data('image')+'" />');
				details.find('.iframe-container').empty().append( image );
			}

		} } )


		var self = this
		this.to = $(window).scrollTop()
		TweenLite.to(self, .5, {
            to: details.offset().top - 100,
            ease: Cubic.easeOut,
            onUpdate: function(){
            	$(window).scrollTop( self.to )
            }
        });

		currentInnovation = target

	}

	function closeDetails( target ){

		if( target != null ){

			target.removeClass('active')

			var num = target.data('num')
			var details = $('.innovation_details_wrapper').eq( num )
			TweenLite.to( target, .6, { height: 220, ease:Cubic.easeInOut } )
			TweenLite.to( details, .6, { height: 0, ease:Cubic.easeInOut} )

			currentInnovation = null

		}

	}

	function doResize(){

		windowWidth = $(window).width()
		windowHeight = $(window).height()
		documentHeight = $(document).height()

		var bodyRect = document.body.getBoundingClientRect()

		$('.parallax_image').each( function(){

			var elemRect = $(this).get(0).getBoundingClientRect()
		    var offset   = elemRect.top - bodyRect.top
			$(this).data('top', offset )
			$(this).data('height', $(this).height() )

		})

		$('.bg-1 img').each( function(){

			var elemRect = $(this).get(0).getBoundingClientRect()
		    var offset   = elemRect.top - bodyRect.top
			$(this).data('top', offset )
			$(this).data('height', $(this).height() )

		})

		if( allloaded ){
			doScroll( window.scrollY )
		}

	}

	function doScroll(scroll_pos) {
	  	// do something with the scroll position
	  	// doResize()

	  	if( allloaded ){

	  		$('.parallax_image').each( function(){

	  			// if( $(this).data('parallax_enabled') == true ){

			  		var top = $(this).data('top') - windowHeight - 200
			  		var bottom = $(this).data('top') + $(this).data('height') + 200// + windowHeight
			  		var diff = windowHeight + $(this).data('height') + 400
			  		// inside
			  		if( top < scroll_pos && bottom > scroll_pos ){
			  			// console.log('inside', scroll_pos - top, (scroll_pos - top) / diff )
			  			var percent = (scroll_pos - top) / diff * 200 - 100
			  			// percent = -percent

			  			$(this).css('transform', 'translate3d(0,'+ (percent/4) +'%,0)')
			  		}

	  			// }

		  	})


	  		$('.bg img').each( function(){

	  			var percent = scroll_pos / documentHeight * 100
	  			var diff = $(this).data('height') - (windowHeight - 250)
	  			diff /= $(this).data('height')
	  			percent *= diff



	  			// if( $(this).data('parallax_enabled') == true ){

			  		// var top = $(this).data('top') - windowHeight - 1000
			  		// var bottom = $(this).data('top') + $(this).data('height') + 1000// + windowHeight
			  		// var diff = windowHeight + $(this).data('height') + 2000
			  		// inside
			  		// if( top < scroll_pos && bottom > scroll_pos ){
			  		// 	var percent = (scroll_pos - top) / diff * 200 - 100
			  		// 	percent = -percent
			  			$(this).css('transform', 'translate3d(-50%,'+ -percent +'%,0)')
			  		// }

	  			// }

		  	})

	  	}

	}

	/* Verbatim page */
	$(document).ready(function() {
    /* Every time the window is scrolled ... */

		$('.hideme').each( function(i){

				var bottom_of_object = $(this).offset().top;
				var bottom_of_window = $(window).scrollTop() + $(window).height();

				/* If the object is completely visible in the window, fade it it */
				if( bottom_of_window > bottom_of_object ){
						// $(this).animate({'opacity':'1'},500);
						// $(this).animate({'margin-top':'0'},500);
						$(this).addClass('verbatim-visible');
				}
		});

    $(window).scroll( function(){
        /* Check the location of each desired element */
        $('.hideme').each( function(i){

            var bottom_of_object = $(this).offset().top + 100;
            var bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){
                // $(this).animate({'opacity':'1'},500);
                // $(this).animate({'margin-top':'0'},500);
								$(this).addClass('verbatim-visible');
            }
        });
    });
});


	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
